import React, { Component } from 'react';
import classes from './Screenshot.module.css';

class Screenshot extends Component {

    viewScreenshot = () => {
        const b64 = this.props.imgIndex;
        const contentType = 'image/png';

        const byteCharacters = atob(b64.substr(`data:${contentType};base64,`.length));
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
            const slice = byteCharacters.slice(offset, offset + 1024);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, '_blank');
    }

    render() {

        return (
            <div id={this.props.imgIndex} className={classes.Screenshot} onClick={this.viewScreenshot}>
                <img alt={this.props.imgIndex} src={this.props.imgIndex} />
                <div className={classes.overlay}>
                    <div className={classes.text}>{this.props.timeStamp}</div>
                </div>
                <div className={classes.description}>
                    Screenshot - {this.props.index}
                </div>
            </div>
        )
    }
}


export default Screenshot;